export default "__VITE_ASSET__Cg$H2Ig4__"